/**
 * Controller: RemoveSecondaryContactModal
 */
angular.module('acme.view.application.partners.create.removeSecondaryContactModal.controllers', [])
.controller('RemoveSecondaryContactModalController', [ '$scope', '$uibModalInstance', 'contact', function($scope, $uibModalInstance, contact) {

    $scope.removeSecondaryContactModal = {

      model: {},

      init: function() {
        this.model = contact;
      },

      done: function() {
        $uibModalInstance.close(this.model);
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      }
    };

    $scope.removeSecondaryContactModal.init();

}]);